/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CollectionResponseApiStatisticsResponse', 'model/CollectionResponseClientStatisticsResponse', 'model/CollectionResponseStatisticsResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/CollectionResponseApiStatisticsResponse'), require('../model/CollectionResponseClientStatisticsResponse'), require('../model/CollectionResponseStatisticsResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.StatisticsApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.CollectionResponseApiStatisticsResponse, root.GisServerApis.CollectionResponseClientStatisticsResponse, root.GisServerApis.CollectionResponseStatisticsResponse);
  }
}(this, function(ApiClient, CollectionResponseApiStatisticsResponse, CollectionResponseClientStatisticsResponse, CollectionResponseStatisticsResponse) {
  'use strict';

  /**
   * Statistics service.
   * @module api/StatisticsApi
   * @version 1.0.0
   */

  /**
   * Constructs a new StatisticsApi. 
   * @alias module:api/StatisticsApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the getStatisticsByApiV1 operation.
     * @callback module:api/StatisticsApi~getStatisticsByApiV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/CollectionResponseApiStatisticsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the latest 24 hours statistics groupped by apis. The amount of each item is aggregated by 10 minutes.
     * @param {module:api/StatisticsApi~getStatisticsByApiV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CollectionResponseApiStatisticsResponse}
     */
    this.getStatisticsByApiV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = CollectionResponseApiStatisticsResponse;

      return this.apiClient.callApi(
        '/api/v1/statistics/byapi', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getStatisticsByClientV1 operation.
     * @callback module:api/StatisticsApi~getStatisticsByClientV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/CollectionResponseClientStatisticsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the latest 24 hours statistics grouped by clients. The amount of each item is aggregated by 10 minutes.
     * @param {module:api/StatisticsApi~getStatisticsByClientV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CollectionResponseClientStatisticsResponse}
     */
    this.getStatisticsByClientV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = CollectionResponseClientStatisticsResponse;

      return this.apiClient.callApi(
        '/api/v1/statistics/byclient', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getStatisticsForAccountV1 operation.
     * @callback module:api/StatisticsApi~getStatisticsForAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/CollectionResponseClientStatisticsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the latest 24 hours statistics for a specified account. The amount of each item is aggregated by 10 minutes.
     * @param {String} accountId The ID of the account to query.
     * @param {module:api/StatisticsApi~getStatisticsForAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CollectionResponseClientStatisticsResponse}
     */
    this.getStatisticsForAccountV1 = function(accountId, callback) {
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getStatisticsForAccountV1");
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = CollectionResponseClientStatisticsResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}/statistics/byclient', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getStatisticsForCurrentAccountV1 operation.
     * @callback module:api/StatisticsApi~getStatisticsForCurrentAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/CollectionResponseClientStatisticsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the latest 24 hours statistics for current account. The amount of each item is aggregated by 10 minutes.
     * @param {module:api/StatisticsApi~getStatisticsForCurrentAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CollectionResponseClientStatisticsResponse}
     */
    this.getStatisticsForCurrentAccountV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = CollectionResponseClientStatisticsResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/current/statistics/byclient', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getStatisticsTotalsV1 operation.
     * @callback module:api/StatisticsApi~getStatisticsTotalsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/CollectionResponseStatisticsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the latest 24 hours statistics totals. The amount of each item is aggregated by 10 minutes.
     * @param {module:api/StatisticsApi~getStatisticsTotalsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CollectionResponseStatisticsResponse}
     */
    this.getStatisticsTotalsV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = CollectionResponseStatisticsResponse;

      return this.apiClient.callApi(
        '/api/v1/statistics', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

